import { Icon } from "@chakra-ui/react"

export const VideoIcon = (props: any) => (
  <Icon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 93.66 104.93">
    <g>
      <path fill="currentColor" className="st0" d="M46.83,7.46c-24.81,0-45,20.19-45,45s20.19,45,45,45c24.81,0,45-20.19,45-45S71.64,7.46,46.83,7.46z
        M46.83,94.1C23.88,94.1,5.2,75.42,5.2,52.46c0-22.95,18.68-41.63,41.63-41.63c22.96,0,41.63,18.68,41.63,41.63
        C88.46,75.42,69.79,94.1,46.83,94.1z"/>
      <path fill="currentColor" className="st0" d="M69.07,49.18l-30.6-17.67c-1.19-0.69-2.61-0.69-3.8,0c-1.19,0.69-1.9,1.92-1.9,3.29v35.33
        c0,1.37,0.71,2.6,1.9,3.29c0.59,0.34,1.25,0.52,1.9,0.52c0.65,0,1.3-0.17,1.9-0.52l30.6-17.67c1.19-0.69,1.9-1.92,1.9-3.29
        C70.97,51.09,70.26,49.86,69.07,49.18z M67.38,52.84L36.79,70.5c-0.18,0.1-0.33,0.06-0.43,0c-0.1-0.06-0.21-0.17-0.21-0.37V34.8
        c0-0.2,0.12-0.31,0.21-0.37c0.06-0.03,0.13-0.06,0.22-0.06c0.06,0,0.14,0.02,0.21,0.06l30.6,17.67c0.18,0.1,0.21,0.26,0.21,0.37
        C67.6,52.58,67.56,52.73,67.38,52.84z"/>
    </g>
  </Icon>
);
